import { mapGetters, mapMutations } from 'vuex'

export const publicTableList = {
  computed: {
    ...mapGetters('versionmanage', ['tableDateList'])
  },
  data () {
    return {
      versionManageflag: false,
      resetSearch: false,
      dateFormat: 'YYYY-MM-DD',
      tableData: [],
      // 全选按钮的所有数据
      allTableData: [],
      // 是否全选标志
      isAllBtn: false,
      tableInfo: {
        total: 0,
        pageIndex: 1,
        pageSize: 10,
        selectRows: [],
        selectRowDate: [],
        pageSizeOptions: ['10', '20', '30', '40', '50', '100'],
        changePageIndex: this.changePageIndex,
        changePageSize: this.changePageSize
      },
      // table加载Loading
      tableLoading: false,
      // 删除按钮Loading
      btnLoading: false,
      // 页面搜索关键词
      searchObj: {},
      // 页面排序参数
      tableSorterType: {},
      // table列表api接口
      tableServices: {
        // 获取
        getServices: '',
        // 删除
        delServices: ''
      },
      headerSelectAll: false,
      statusData: [] // 故障监测弹框数据
    }
  },
  methods: {
    ...mapMutations('versionmanage', ['DELETE_TABLETADE', 'UPDATE_TABLETADE']),
    // changePageIndex
    changePageIndex (page, pageSize) {
      this.tableInfo.pageIndex = page
      this.getTableData()
    },

    // changePageSize
    changePageSize (current, pageSize) {
      this.tableInfo.pageIndex = 1
      this.tableInfo.pageSize = pageSize
      this.getTableData()
    },

    // 改变头部第一个搜索框input的值
    changeBasicSearchFun (val) {
      let str = val.replace(/^\s*|\s*$/g, '')
      this.searchObj.name = str
    },

    // search
    onTableSearchFun () {
      this.tableInfo.pageIndex = 1
      this.tableInfo.pageSize = 10
      this.getTableData()
    },

    // table勾选
    selectTableRowFun (selectedRowKeys, headerSelectAll, selectedRows) {
      this.tableInfo.selectRows = selectedRowKeys
      this.tableInfo.selectRowDate = selectedRows
      // 如果勾选了table的顶部选择框↓↓
      this.headerSelectAll = headerSelectAll
    },

    // 顶部全选按钮
    async selectAllFun () {
      let list = this.tableInfo.selectRows
      let total = this.tableInfo.total
      if (list.length === total) {
        this.tableInfo.selectRows = []
        this.tableInfo.selectRowDate = []
        this.tableInfo.selectRows = []
        this.allTableData = []
        this.isAllBtn = false
      } else {
        // 如果total大于10，则pageSize为全选总数
        if (total > 10) {
          this.isAllBtn = true
          this.tableInfo.selectRowDate = this.allTableData
          await this.getTableData('', true)
          if (this.allTableData[0].sn) {
            this.tableInfo.selectRows = this.allTableData.map(i => {
              return i.sn
            })
          } else {
            this.tableInfo.selectRows = this.allTableData.map(i => {
              return i.id
            })
          }
        } else {
          this.tableInfo.selectRowDate = this.tableData
          if (this.tableData[0].sn) {
            this.tableInfo.selectRows = this.tableData.map(i => {
              return i.sn
            })
          } else {
            this.tableInfo.selectRows = this.tableData.map(i => {
              return i.id
            })
          }
        }
      }
    },

    // table排序
    tableSorterFun (column) {
      console.log('table排序column=====', column)
      this.tableSorterType = {}
      if (JSON.stringify(column) !== '{}') {
        // 排序的列名
        let type = column.field
        // 升序?降序?
        let flag = column.order !== 'ascend'
        switch (type) {
          case 'createTime':
            this.tableSorterType['timeOrder'] = flag
            break
          case 'version':
            this.tableSorterType['versionOrder'] = flag
            break
          case 'type':
            this.tableSorterType['typeOrder'] = flag
            break
          case 'size':
            this.tableSorterType['sizeOrder'] = flag
            break
          case 'state':
            this.tableSorterType['stateOrder'] = flag
            break
          case 'number':
            this.tableSorterType['numberOrder'] = flag
            break

          default:
            break
        }
      }
      this.getTableData()
    },

    // 表头删除按钮
    topBarDelBtnFun () {
      let list = this.tableInfo.selectRows
      if (list.length === 0) {
        this.$message.warning('请选择需要删除的数据')
      } else {
        this.$refs.delWeight.isShow = true
      }
    },

    // table-单行删除
    rowDel (item) {
      if (item.sn) {
        this.tableInfo.selectRows = [item.sn]
      } else {
        this.tableInfo.selectRows = [item.id]
      }
      this.$refs.delWeight.isShow = true
    },

    // 删除接口调用
    async delTableDataFun () {
      this.btnLoading = true
      let res = await this.tableServices.delServices(this.tableInfo.selectRows)
      this.btnLoading = false
      this.$refs.delWeight.isShow = false
      if (res.status === 0) {
        this.notification('success', '成功', '删除成功')
        this.tableInfo.selectRows = []

        // 点击"全选"后>>重置
        if (this.isAllBtn) {
          this.tableInfo.pageIndex = 1
          this.tableInfo.pageSize = 10
        }
        // 删除当前页Table所有数据>>重置
        if (this.headerSelectAll) {
          this.tableInfo.pageIndex = 1
          this.tableInfo.pageSize = 10
          this.headerSelectAll = false
        }

        this.getTableData()
      }
    },

    // 重置按钮
    resetSearchFun () {
      this.searchObj = {}
      this.resetSearch = true
      this.getTableData()
    },
    unresetSearchFun () {
      this.resetSearch = false
    },

    // table当前页数据
    async getTableData (services, ifAll = false) {
      if (services) {
        this.tableServices.getServices = services
      }
      let query = {
        pageIndex: ifAll ? 1 : this.tableInfo.pageIndex,
        pageSize: ifAll ? this.tableInfo.total : this.tableInfo.pageSize
      }

      // 页面搜索条件(包含"基本搜索"、"高级搜索")
      if (this.searchObj) {
        for (const key in this.searchObj) {
          if (this.searchObj.hasOwnProperty(key) && this.searchObj[key]) {
            query[key] = this.searchObj[key]
          }
        }
      }

      // 页面排序条件
      if (JSON.stringify(this.tableSorterType) !== '{}') {
        for (let key in this.tableSorterType) {
          query[key] = this.tableSorterType[key]
        }
      }
      console.log('query----', query)

      if (this.tableServices.getServices) {
        this.tableLoading = true
        let res = await this.tableServices.getServices(query)
        this.tableLoading = false
        if (res.status === 0) {
          if (!ifAll) {
            if (this.versionManageflag) {
              this.UPDATE_TABLETADE(res.result.list)
              this.tableData = this.tableDateList
            } else {
              this.tableData = res.result.list
            }
            this.tableInfo.total = res.result.total
          } else {
            this.allTableData = res.result.list
          }
        }
      }
    }
  }
}
export const devicePublic = {
  data () {
    return {
      modalShow: false,
      updateLoading: false,
      // 选择的固件id
      versionId: '',
      // 故障状态弹窗api接口
      statusServices: '',
      // 重启设备api接口
      rebootServices: '',
      // 重启Loading
      rebootLoading: false,
      columns: [
        {
          title: '机构名称',
          dataIndex: 'areaName',
          type: 'tooltip', // 有气泡
          width: 150
        },
        {
          title: '设备名称',
          dataIndex: 'name',
          width: 220,
          type: 'tooltip'
        },
        {
          title: '设备型号',
          dataIndex: 'deviceType',
          width: 165,
          type: 'tooltip'
        },
        {
          title: '设备状态',
          dataIndex: 'state',
          custom: true, // 自定义渲染文字
          sorter: true,
          width: 120
        },
        {
          title: '故障监测',
          dataIndex: 'instruc',
          fun: this.lookStatusFun,
          type: 'cellClick',
          custom: true,
          width: 120
        },
        {
          title: 'SN码',
          dataIndex: 'sn',
          width: 225,
          type: 'tooltip'
        },
        {
          title: '本地IP',
          dataIndex: 'ip',
          width: 194
        },
        {
          title: '固件版本',
          dataIndex: 'version'
        }
      ],
      topBarBtns: [
        {
          name: '版本升级',
          type: 'primary',
          fun: this.openUpdate
        },
        {
          name: '重启',
          type: 'primary',
          fun: this.restartDevice
        },
        {
          name: '全选',
          type: '',
          fun: this.selectAllFun
        }
      ],
      // 升级固件Api
      updateServices: {}
    }
  },
  methods: {
    // 点击"故障检测"列的弹窗
    lookStatusFun (val) {
      this.$refs.statusWeight.isShow = true
      val.statustype = this.routes[0].name
      console.log('故障监测========', val)
      this.statusData = val
    },

    // 批量重启
    async restartDevice () {
      // 调用相关api接口
      if (this.tableInfo.selectRows.length > 0) {
        this.rebootLoading = true
        let res = await this.rebootServices({
          list: this.tableInfo.selectRows
        })
        setTimeout(() => {
          this.rebootLoading = false
        }, 1000)
        if (res.status === 0) {
          this.notification('success', '成功', res.result)
        }
        this.tableInfo.selectRows = []
        this.tableInfo.pageIndex = 1
        this.tableInfo.pageSize = 10
        this.getTableData()
      } else {
        this.$message.warning('请选择需要重启的设备')
      }
    },

    // 打开升级弹窗
    openUpdate () {
      if (this.tableInfo.selectRows.length > 0) {
        this.modalShow = true
      } else {
        this.$message.warning('请选择需要升级的设备')
      }
    },

    // 关闭升级弹窗
    closeUpdate () {
      this.updateLoading = false
      this.modalShow = false
    },

    // 选择固件版本
    checkedVersion (val) {
      this.versionId = val
    },

    // 升级
    async updateMe (path) {
      this.updateLoading = true
      // 调用接口↓↓↓
      let data = {
        list: this.tableInfo.selectRows,
        id: this.versionId
      }
      let res = await this.updateServices.updateApi(data)
      if (res.status === 0) {
        this.notification('success', '成功', res.result)
      }
      this.updateLoading = false
      this.modalShow = false
      this.tableInfo.selectRows = []
      this.tableInfo.pageIndex = 1
      this.tableInfo.pageSize = 10
      this.getTableData()
    }
  }
}
